angular.module( 'acme.view.application.pos.create.pages', [
  'ui.router',
  'ui.bootstrap',
  'ui.scrollfix',
  'acme.common.directive.customTypeahead',
  'acme.view.application.pos.create.pages.controllers',
  'acme.view.application.pos.create.pages.forms.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePages = {
        name: 'application.pos.create.pages',
        url: '/pages',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/pages.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      },
      posEditPages = {
        name: 'application.pos.edit.pages',
        url: '/pages',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/pages.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator'
        }
      };

    $stateProvider
      .state(posCreatePages)
      .state(posEditPages);
});
